export class  MessageConstant {
   
    
    //error message
    public static errorMessage = 'Please try agin later';
    public static formInvalid = 'Form invalid'
    //common message
    public static deleteMessage = 'Deleted successfully';
    public static recordUpdateMessage = 'Record updated successfully!';
    public static customLocationMessage = 'Please choose your custom location';
    public static NoRecordFoundMessage = 'No records found!';
    //chargerModel
    public static chargerCreateMessage ='Charging Model created!';
    //chargerCreate
    public static chargerNCreate = 'Charger created!';
    public static chargerMappedWithStation = 'Charger are mapped with station';
    public static dublicateCharger = "Serial no or display id already mapped with other charger ";
    //chargerStation
    public static chargerStationCreate = 'Charging station created!';
    public static chargerAlMapped = 'Charger already mapped to other Charging Station!';
    public static ChargerRemoved = 'Charger removed!';
    //ClientManagment
    public static clientCreate = 'Client created!';
    //CPO Managment
    public static cpoCreate = 'CPO created!';
    //LogsandHistory
    public static changeAvailability  = 'Please provide availability type.';
    public static messageOcppIDTag = 'Please provide ocpp id tag.';
    
    //vehicle
    public static vehicleCreate = 'Vehicle Registered!';
    public static publishedMessage = 'Published successfully';
    //session module message
    public static  loginSuccessMessage = 'Authentication successful!';
    public static  loginInvaildDetails = 'Incorrect  username or password ';
    public static  loginInvaildUser = 'Username  incorrect ';
    public static  loginInvaildPassword = 'Password  incorrect ';
    public static  userOTPSend  = 'OTP send to your registered mobile number';
    public static validOTPError = 'Please provide valid otp number';
    public static validRegNumber = 'Please provide register mobile number';
    public static userRegisterdMessage = 'User registered successfully';
    public static getOTPMessage = 'OTP send to your registered mobile number';
    public static dublicateRegistrationMessage = 'Mobile no or email is already assoicated with other user';
    public static salesDispatch = "Sales dispatch successfully!";
    public static serialBoxEmpty = "Please select or export valid serial number";
    public static errorOTP = "Please enter valid OTP";
    public static requestCopied = 'Request JSON Copied';
    public static responseCopied = 'Response JSON Copied';
    public static cpoDuplicate = "This CPO already assign to this client";
    public static mobileDuplicateCPO = "Mobile number already assign to other cpo";
    public static emailDuplicateCPO = "Email already assign to other cpo";
    public static clientDuplicate = "Name already assign to other client";
    public static emailDuplicateClient = "Email already assign to other cpo";
    public static mobileDuplicateClient = "Mobile number already assign to other cpo";
    public static chargingStationDuplicate = "Name already assign to other Charging station";
    public static roleCreated= "Role created successfully !";
    public static userCreated = 'User created successfully';
    public static userRoleAssign = 'User role assign successfully';
    public static userStationAssign = 'User station assign successfully';
    public static userDuplicate = "Username already assign";
    public static mobileDuplicate = "Mobile number already assign to other station";
    public static mobileDuplicateUser = "Mobile number already assign to other user";
    // public static mobileDuplicate = "Mobile number already assign to other user";
    public static emailDuplicateUser = "Email already assign to other user";
    public static panDuplicateUser = "Pan number assign to other user";
    public static aadharDuplicateUser = "Aadhar number assign to other user";
    public static nameDuplicateCountry = "Country already created";
    public static isoDuplicateCountry = "ISO code assign to other country";
    public static countryCodeDuplicateCountry = "Country code assign to other country";
    public static nameDuplicateState = "State already created";
    public static nameDuplicateCity = "City already created";
    public static registrationDuplicateVehicle = "Registration number already assign to other vehicle";
    public static engineDuplicateVehicle = "Engine number already assign to other vehicle";
    public static chassisDuplicateVehicle = "Chassis number already assign to other vehicle";
    public static clientMenuMappedSucess = "Client menu mapped successfully!";
    public static roleMenuMappedSucess = "Role menu mapped successfully!";
    public static clientModuleCreateMessage = 'Client module mapping successfully ! ';
    public static BookingCreateMessage = 'Booking create successfully ';
    public static BookingAvailableMessage = 'Booking available slot found ';
    public static startTimeLessthen = 'Booking start time incorrect';
    public static pendingPaymentApproved = 'Payment approved successfully !';
    public static bookingApproved = 'Booking approved successfully !';
    public static statePinMapped = "State pins successfully!";
    public static pinError = "Please fill pin code";
    public static statusFalse ="API Status false data not found";
    public static chargingProfileCreate = "Charging profile created successfully !";
    public static chargingScheduleCreate = "Charging schedule created successfully !";
    public static chargingSchedulePeriodCreate = "Charging schedule period created successfully !";
    //public static chargerProfileUpdate = "First create charging profile!";
// public static chargerScheduleUpdate = "First create charging profile and charging schedule!";
    public static menuMasterCreate = "Menu master created successfully !"
    public static evChargingSolutionCreate = "EV Charging solution created successfully !";
    public static bookingConfigCreate = "Booking config created successfully !";
    public static bookingConfigAlReadyMapped = "Booking config is already mapped  !";
    public static errorMessageForChargingProfileSchedule = "First create charging schedule to update!";
    public static errorMessageForChargingProfilePeriod = "First create charging  schedule period to update!";
    public static notificationCreate = "Notification Engine created successfully !";
    public static subsidyCreate = 'Govt Subsidy created successfully!';
    public static evFleetCreate = 'EvFleet created successfully';
    public static chargerRequest = 'Charger request created successfully !';
    public static evCharhingStation = 'EV Charging station request created successfully !';
    public static like = 'You like this station !';
    public static dislike = 'You Dislike this station !';
}